export const COLOR_TO_FREQ = {
  '#FFFFFF': 130,
  '#FFF': 130, // This should not happen.
  '#FFFF00': 140,
  '#FF00FF': 150,
  '#0000FF': 160,
  '#000000': 170,
  '#000': 170, // This should not happen.
};

export const FILENAMES = [
  'masterpiece',
  'art',
  'professional-painting',
  'artwork',
];

export const FILENAME_ADJECTIVES = [
  '-such-wow',
  '-much-wow',
  '-so-great',
  '-so-good',
  '-tis-great',
  '-tis-good',
  '-very-want',
  '',
];
